import _jsx from "@babel/runtime/helpers/jsx";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import _ from 'lodash';
import { defineMessages } from 'react-intl';
import { loadFavoriteCourses } from '../../actions/auth';
import { getCourses, reset } from '../../actions/courses';
import { getLessons, resetLessons } from '../../actions/homeLessons';
import { changeSearchField, changeSearchSession, changeContentCategoriesField, changeTagsField } from '../../actions/search';
import { getContentCategories } from '../../actions/contentCategories';
import { getTags } from '../../actions/tags';
import Layout from '../../components/Layout';
import { getContentCategoriesForFilter, ssrRequest } from '../../helpers';
import isLoggedIn from '../../helpers/checkAuth';
import Courses from './Courses';
import initialState from './intialState';
var messages = defineMessages({
  title: {
    id: "Courses.title",
    defaultMessage: [{
      "type": 0,
      "value": "Healthcare E-learning"
    }]
  },
  description: {
    id: "Courses.description",
    defaultMessage: [{
      "type": 0,
      "value": "Skhole creates the new universal standard for healthcare education. The best online learning from Finland to serve the whole world."
    }]
  }
});
function action(_x) {
  return _action.apply(this, arguments);
}
function _action() {
  _action = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context) {
    var _updatedContentCatego,
      _this = this;
    var store, fetch, formatMessage, query, serverUrl, organizationSlug, whitelabeling, cloudfrontUrl, contentLangs, _store$getState, auth, locale, promises, perPage, page, isInitialContentCategoriesLoad, updatedContentCategories, contentLangId, _contentLangs$find, search, sort, title, description, imageUrl, customDescription, customTitle, ogImage, prevUrl, nextUrl, canonicalUrl, _store$getState2, total, tags, homeLessons, searchSession, contentCategories, keywords, listMode, newSearchSessionRes, newSearchSession;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          store = context.store, fetch = context.fetch, formatMessage = context.intl.formatMessage, query = context.query, serverUrl = context.serverUrl, organizationSlug = context.organizationSlug, whitelabeling = context.whitelabeling, cloudfrontUrl = context.cloudfrontUrl, contentLangs = context.contentLangs;
          _store$getState = store.getState(), auth = _store$getState.auth, locale = _store$getState.intl.locale;
          promises = [];
          perPage = 32;
          page = query.page || 1;
          isInitialContentCategoriesLoad = store.getState().search.isInitialContentCategoriesLoad;
          updatedContentCategories = query.contentCategories || initialState.contentCategories;
          if (isInitialContentCategoriesLoad && !((_updatedContentCatego = updatedContentCategories) !== null && _updatedContentCatego !== void 0 && _updatedContentCatego.length)) {
            updatedContentCategories = getContentCategoriesForFilter(auth);
          }
          promises.push(function () {
            return store.dispatch(changeContentCategoriesField(updatedContentCategories || []));
          });
          promises.push(function () {
            return store.dispatch(changeTagsField(query.tags || initialState.tags));
          });
          promises.push(function () {
            return store.dispatch(changeSearchField(query.search || initialState.search));
          });
          contentLangId = _.isString(query.contentLangId) ? query.contentLangId : '';
          if (!contentLangId) {
            contentLangId = contentLangs === null || contentLangs === void 0 ? void 0 : (_contentLangs$find = contentLangs.find(function (item) {
              return item.lang === locale;
            })) === null || _contentLangs$find === void 0 ? void 0 : _contentLangs$find._id;
          }
          search = _.isString(query.search) ? query.search : initialState.search;
          if (contentLangId === 'all' || search) {
            contentLangId = '';
          }
          sort = _.isString(query.sort) ? query.sort : initialState.sort;
          if (search) {
            sort = '';
          }
          promises.push(function () {
            var q = {
              page: page,
              perPage: perPage,
              sort: sort,
              contentLangId: contentLangId,
              type: _.isString(query.type) ? query.type : initialState.type,
              filter: _.isString(query.filter) ? query.filter : initialState.filter,
              contentCategories: _.isArray(updatedContentCategories) && !search ? updatedContentCategories : [],
              search: search,
              tags: _.isArray(query.tags) && !search ? query.tags : [],
              includeNotAvailable: true
            };
            return ssrRequest({
              getAction: getCourses.bind(_this, q),
              resetAction: reset,
              store: store,
              fetch: fetch,
              context: context
            });
          });
          promises.push(function () {
            if (_.trim(query.search).length < 3) {
              return Promise.resolve();
            }
            var q = {
              page: 1,
              perPage: perPage,
              sort: _.isString(query.sort) ? query.sort : initialState.sort,
              contentLangId: contentLangId,
              tags: _.isArray(query.tags) ? query.tags : initialState.tags,
              search: _.isString(query.search) ? query.search : initialState.search,
              isHomePage: true,
              withoutPopulation: true,
              includeNotAvailable: true
            };
            return ssrRequest({
              getAction: getLessons.bind(_this, q),
              resetAction: resetLessons,
              store: store,
              fetch: fetch,
              context: context
            });
          });
          if (isLoggedIn(auth)) {
            promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    return _context.abrupt("return", store.dispatch(loadFavoriteCourses(fetch)));
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })));
            promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    return _context2.abrupt("return", ssrRequest({
                      getAction: getContentCategories.bind(_this, {
                        page: 1,
                        perPage: 50,
                        sort: "name.".concat(locale),
                        search: '',
                        isGeneral: false
                      }),
                      store: store,
                      fetch: fetch,
                      context: context
                    }));
                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            })));
          } else {
            promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    return _context3.abrupt("return", ssrRequest({
                      getAction: getTags.bind(_this, {
                        page: 1,
                        perPage: 50,
                        sort: 'name',
                        contentLangId: contentLangId,
                        isHomePageSearch: true
                      }),
                      store: store,
                      fetch: fetch,
                      context: context
                    }));
                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            })));
          }
          _context4.next = 22;
          return Promise.all(promises.map(function (promise) {
            return promise();
          }));
        case 22:
          title = formatMessage(messages.title);
          description = formatMessage(messages.description);
          if (organizationSlug) {
            customDescription = _.get(whitelabeling, "serviceDescription.".concat(locale));
            customTitle = _.get(whitelabeling, "indexTitle.".concat(locale));
            ogImage = _.get(whitelabeling, "ogImage");
            if (title) {
              title = customTitle;
            }
            if (customDescription) {
              description = customDescription;
            }
            if (ogImage) {
              imageUrl = "".concat(cloudfrontUrl).concat(ogImage);
            }
          }
          canonicalUrl = "".concat(serverUrl).concat(page > 1 ? "/".concat(locale).concat(organizationSlug ? "/".concat(organizationSlug) : '', "?page=").concat(page) : '');
          _store$getState2 = store.getState(), total = _store$getState2.courses.total, tags = _store$getState2.tags.tags, homeLessons = _store$getState2.homeLessons, searchSession = _store$getState2.search.searchSession, contentCategories = _store$getState2.contentCategories.contentCategories;
          if (page > 1 && page <= Math.ceil(total / perPage)) {
            prevUrl = "".concat(serverUrl).concat(page - 1 > 1 ? "/".concat(locale).concat(organizationSlug ? "/".concat(organizationSlug) : '', "?page=").concat(page - 1) : '');
          }
          if (page < Math.ceil(total / perPage)) {
            nextUrl = "".concat(serverUrl, "/").concat(locale).concat(organizationSlug ? "/".concat(organizationSlug) : '', "?page=").concat(page + 1);
          }
          keywords = [].concat(_toConsumableArray(_.map(tags || [], 'name')), _toConsumableArray(_.map(contentCategories || [], "name.".concat(locale))));
          listMode = false;
          if (query.listMode || _.get(auth, 'user.listMode')) {
            listMode = true;
          }
          if (!(isLoggedIn(auth) && _.trim(query.search).length >= 3 && !searchSession._id)) {
            _context4.next = 47;
            break;
          }
          _context4.prev = 33;
          _context4.next = 36;
          return fetch('/api/courses/search-session', {
            method: 'POST',
            body: JSON.stringify({
              searchPhrase: query.search,
              foundCoursesAmount: total,
              foundLessonsAmount: homeLessons.total,
              tags: []
            })
          });
        case 36:
          newSearchSessionRes = _context4.sent;
          if (!(newSearchSessionRes.status === 201)) {
            _context4.next = 42;
            break;
          }
          _context4.next = 40;
          return newSearchSessionRes.json();
        case 40:
          newSearchSession = _context4.sent;
          store.dispatch(changeSearchSession(newSearchSession._id, query.search));
        case 42:
          _context4.next = 47;
          break;
        case 44:
          _context4.prev = 44;
          _context4.t0 = _context4["catch"](33);
          console.error(_context4.t0);
        case 47:
          return _context4.abrupt("return", {
            chunks: ['home'],
            title: title,
            keywords: keywords,
            description: description,
            prevUrl: prevUrl,
            canonicalUrl: canonicalUrl,
            nextUrl: nextUrl,
            imageUrl: imageUrl,
            component: /*#__PURE__*/_jsx(Layout, {
              context: context,
              tour: "courses"
            }, void 0, /*#__PURE__*/_jsx(Courses, {
              data: {},
              title: title,
              page: page,
              query: query,
              listMode: listMode
            }))
          });
        case 48:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[33, 44]]);
  }));
  return _action.apply(this, arguments);
}
export default action;